import { ModalDialogService } from '../modal-dialog';

export abstract class ModalBase {
  abstract input: any;
  destroy: Function;
  private _mService: ModalDialogService;

  constructor(modalService: ModalDialogService) {
    this._mService = modalService;
  }

  abstract submit(data?: any);

  close(data?: any) {
    this.destroy();
    this._mService.close(this.constructor, data);
  }
}
